import * as React from 'react'
import { Icon } from '@blueprintjs/core'

interface Props {
  elapsedSeconds: number
}

export const Timer: React.FC<Props> = props => {
  const minutes = Math.floor(props.elapsedSeconds / 60)
  const seconds = props.elapsedSeconds % 60

  let timerString
  if (props.elapsedSeconds < 60) {
    timerString = `${props.elapsedSeconds} sec`
  } else {
    timerString = `${minutes} min ${seconds} sec`
  }

  return (
    <div className="time-container">
      <Icon icon="time" color="#DEE2E6" />
      <span className="time-string">{timerString}</span>
    </div>
  )
}
